module.exports = __webpack_public_path__ + "791bf65ab957636794a50aa500c5bfb8.svg";